

























































































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import { getAllTasks } from '@/request/apis/TaskManagementRequest'
import PreProcessingResult from '@/views/home/PreProcessingResult.vue'
import ClusteringResult from '@/views/home/ClusteringResult.vue'
import DifferentialExpressionResult from '@/views/home/DifferentialExpressionResult.vue'
import { ElTable } from 'element-ui/types/table'
import { TaskDetail } from '@/types/Task'
import CellTypeAnnotationResult from '@/views/home/CellTypeAnnotationResult.vue'
import DataIntegrationResult from '@/views/home/DataIntegrationResult.vue'
import TrajectoryAnalysisResult from '@/views/home/TrajectoryAnalysisResult.vue'
import AdvancedDownstreamAnalysisResult from '@/views/home/AdvancedDownstreamAnalysisResult.vue'
import GeneSetEnrichmentResult from '@/views/home/GeneSetEnrichmentResult.vue'
import CellCommunicationResult from '@/views/home/CellCommunicationResult.vue'
import InferCNVResult from '@/views/home/InferCNVResult.vue'

@Component({
  components: {
    InferCNVResult,
    CellCommunicationResult,
    GeneSetEnrichmentResult,
    AdvancedDownstreamAnalysisResult,
    TrajectoryAnalysisResult,
    DataIntegrationResult,
    CellTypeAnnotationResult,
    DifferentialExpressionResult,
    ClusteringResult,
    PreProcessingResult }
})
export default class RecentTasks extends Vue {
  @Ref('displayTable') displayTable!: ElTable
  @Ref('selectTable') selectTable!: ElTable

  private displayCount: number = 10 // 最大展示任务数量
  private recentCount: number = 50 // 可选择的任务数量
  private displayList: any[] = [] // 展示的任务列表
  private selectList: any[] = [] // 可选择的任务列表
  private addList: any[] = [] // 选中添加的任务列表
  private highlightIndex: number = 0 // 高亮行的index
  private displayModule: string = ''
  private dialogVisible: boolean = false

  /**
   * 获取当前行的任务结果
   * @param row 当前行
   */
  private getRowResult (row: TaskDetail) {
    // 获取当前行的index
    for (let [index, item] of this.displayList.entries()) {
      if (item.job_id === row.job_id) {
        this.highlightIndex = index
        break
      }
    }
    this.$route.params.id = row.job_id
    this.displayModule = row.module
    this.$forceUpdate()
  }

  /**
   * 根据筛选情况获取任务列表，默认显示所有
   */
  private async getDisplayTaskList () {
    try {
      const displayListRes = await getAllTasks(null, {
        module: 'showAll',
        task_status: 'complete',
        create_time: 'showAll',
        count: this.displayCount
      }).start()
      this.displayList = displayListRes.tasks
    } catch (e) {
      console.warn(e)
    }
  }

  /**
   * 根据筛选情况获取任务列表，默认显示所有
   */
  private async getSelectTaskList () {
    this.dialogVisible = true
    try {
      const selectListRes = await getAllTasks(null, {
        module: 'showAll',
        task_status: 'complete',
        create_time: 'showAll',
        count: this.recentCount
      }).start()
      this.selectList = selectListRes.tasks
    } catch (e) {
      console.warn(e)
    }
  }

  /**
   * 设置行高亮
   * @param index 行序号
   */
  private setHighlightRow (index: number) {
    this.highlightIndex = index < 0 ? 0 : index
    this.displayTable.setCurrentRow(this.displayTable.data[this.highlightIndex])
    this.getRowResult(this.displayTable.data[this.highlightIndex] as TaskDetail)
  }

  /**
   * 移除任务
   * @param i 行序号
   */
  private async removeTask (i: number) {
    // 如果删除当前行，高亮转移到上一行
    if (this.highlightIndex === i) {
      setTimeout(() => {
        this.setHighlightRow(i - 1)
      }, 0)
    }
    this.displayList.splice(i, 1)
  }

  /**
   * 禁用已存在任务/超出数量限制的 checkbox
   * @param row 当前行
   */
  private selectableHandler (row: TaskDetail) {
    const leftCount = this.displayCount - this.displayList.length
    if (this.displayList.some(item => item.job_id === row.job_id)) return false
    if (this.addList.some(item => item.job_id === row.job_id)) return true
    else return this.addList.length < leftCount
  }

  /**
   * 更新选中的任务列表
   * @param selection
   */
  private selectTaskHandler (selection: any[]) {
    this.addList = selection
  }

  // 添加任务显示, 清空选择的 checkbox
  private addTaskHandler () {
    this.displayList.push(...this.addList)
    this.dialogVisible = false
    this.selectTable.clearSelection()
    this.addList = []
  }

  async mounted () {
    // 默认高亮并显示第一条结果
    await this.getDisplayTaskList()
    this.$nextTick(() => {
      this.setHighlightRow(0)
    })
  }
}
